import React from "react";
import Button from "@mui/material/Button";
import FilterListIcon from "@mui/icons-material/FilterList";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
// import { Box } from "@mui/material";

//define types for props
interface ActionButtonsProps {
  onSaveDraft: () => void;
  onSubmit: () => void;
  onDownload: () => void;
  onRefresh: (typeOfAction: string) => void;
  disabled?: boolean;
  isFilterChanged?: boolean;
  isSignedOff?: boolean;
  commentsChanged?: boolean;
  disableRefresh?: boolean;
}
const ActionButtons: React.FC<ActionButtonsProps> = ({
  onSaveDraft,
  onSubmit,
  onDownload,
  onRefresh,
  disabled,
  commentsChanged,
  isFilterChanged,
  isSignedOff,
  disableRefresh,
}) => (
  <>
    <Button
      variant="contained"
      startIcon={<FilterListIcon />}
      disabled={isFilterChanged || isSignedOff || disabled}
      sx={{
        backgroundColor: "#0814A0",
        color: "white",
        borderRadius: "20px",
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "11px",
        px: 2,
        "&:hover": { backgroundColor: "#0f20c5" },
      }}
      onClick={onSaveDraft}
    >
      Save as Draft
    </Button>
    <Button
      variant="contained"
      startIcon={<CheckCircleIcon />}
      disabled={isFilterChanged || isSignedOff || disabled}
      sx={{
        backgroundColor: "#0814A0",
        color: "white",
        borderRadius: "20px",
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "11px",
        ml: 1,
        px: 2,
        "&:hover": { backgroundColor: "#0f20c5" },
      }}
      onClick={onSubmit}
    >
      Submit for Review
    </Button>
    <Button
      variant="contained"
      startIcon={<DownloadIcon />}
      disabled={commentsChanged || isFilterChanged}
      sx={{
        backgroundColor: "#18B4FF",
        color: "white",
        borderRadius: "20px",
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "11px",
        ml: 1,
        px: 2,
        "&:hover": { backgroundColor: "#0fa9f3" },
      }}
      onClick={onDownload}
    >
      Download
    </Button>
    <Button
      variant="contained"
      startIcon={<RefreshIcon />}
      disabled={isFilterChanged || isSignedOff || commentsChanged || disableRefresh}
      sx={{
        backgroundColor: "#18B4FF",
        color: "white",
        borderRadius: "20px",
        textTransform: "none",
        fontWeight: "bold",
        fontSize: "11px",
        ml: 1,
        px: 2,
        "&:hover": { backgroundColor: "#0fa9f3" },
      }}
      onClick={() => onRefresh("Refresh")}
    >
      Refresh
    </Button>
  </>
);

export default ActionButtons;
